<template>
  <div id="app">
    <layoutLoginReg v-if="$route.meta.loginReg">
      <router-view />
    </layoutLoginReg>
    <layoutMenu v-else>
      <router-view />
    </layoutMenu>
    <advisory  v-if="!$route.meta.loginReg"/>
  </div>
</template>

<script>
import layoutLoginReg from "./components/layout/loginReg/index"
import layoutMenu from "./components/layout/menu/index"
import advisory from "./components/advisory/index"
export default {
  name: "App",
  components: {
    layoutLoginReg,
    layoutMenu,
    advisory
  }
}
</script>

<style>
html,
body {
  height: 100%;
  overflow-y: hidden;
  min-width: 1280px;
}
.ivu-table-wrapper .ivu-table .ivu-table-body table .ivu-table-tbody .ivu-table-row .ivu-table-cell{
  padding: 6px 18px;
}
</style>
<style lang="scss" scoped>
@import url("https://img.233.com/www/img/wangxiaodaili/public_wxdl_backstage.css");
#app {
  font-family: 'Microsoft YaHei';
  height: 100%;
}
</style>